import { render, staticRenderFns } from "./MainBarMenu.vue?vue&type=template&id=dc64886a&scoped=true"
import script from "./MainBarMenu.vue?vue&type=script&lang=js"
export * from "./MainBarMenu.vue?vue&type=script&lang=js"
import style0 from "./MainBarMenu.vue?vue&type=style&index=0&id=dc64886a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc64886a",
  null
  
)

export default component.exports